import createReactComponent from '../createReactComponent';
export default createReactComponent('border-sides', 'IconBorderSides', [
  ['path', { d: 'M4 8v8', key: 'svg-0' }],
  ['path', { d: 'M20 16v-8', key: 'svg-1' }],
  ['path', { d: 'M8 4h8', key: 'svg-2' }],
  ['path', { d: 'M8 20h8', key: 'svg-3' }],
]);
